export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pokud zrušíte obchod, bude uzavřen bez dokončení operace."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jste si jisti, že chcete zrušit obchod?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ano, zrušit"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ne, ponechat aktivní"])}
}